import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    factoryName: '雄星亚克力制品有限公司',
    user: { name: '老板', role: '管理员' }
  },
  mutations: {},
  actions: {},
  modules: {}
})
